import classnames from 'classnames';
import React from 'react';
import { invokeEvent, ROOT_SOURCE } from 'shared-base';
import { useCustomEvent } from '../../hooks/useCustomEvent';
import IconMenu from '../IconMenu/IconMenu';
import { actions } from './AssetPackList.data';
import { Actions, Image, Thumb, Title } from './AssetPackList.style';

export type AssetPackItemProps = {
  model: IModel;
  isHovered: boolean;
  onPick: (id: string) => void;
  onMouseOver: (id: string) => void;
  onAction: OnAction;
  style: any;
};

export function AssetPackItem(props: AssetPackItemProps) {
  const { model, isHovered } = props;
  // const isLoading = useImage(`${BASE}${model.generatorId}/thumb.png`);

  function onClick(model: IModel, ev: React.MouseEvent<HTMLDivElement>) {
    props.onPick(model.id);
  }

  const className = classnames('thumb', {
    hovered: isHovered,
  });

  function onDragStart(ev: React.DragEvent) {
    ev.dataTransfer.setData('text/plain', model.id);
    invokeEvent('dragStart', { type: 'model' });
  }

  function onDragEnd(ev: React.DragEvent) {
    ev.preventDefault();
    invokeEvent('dragEnd');
  }

  useCustomEvent('modelDropped', (data: Json) => {
    const { itemId } = data;
    props.onPick(itemId);
  });

  function renderImage() {
    // if (isLoading)
    //   return (
    //     <ImageLoader>
    //       <Loader color='pink' />
    //     </ImageLoader>
    //   );

    return (
      <Image
        src={`${ROOT_SOURCE}/${model.generatorId}.png`}
        draggable={true}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
      />
    );
  }

  function renderActions() {
    if (!isHovered) return null;

    return (
      <Actions>
        <IconMenu actions={actions} itemId={model.id} onAction={props.onAction} />
      </Actions>
    );
  }

  return (
    <Thumb
      key={model.id}
      className={className}
      onClick={(ev) => onClick(model, ev)}
      onMouseOver={() => props.onMouseOver(model.id)}
      style={props.style}
    >
      {renderImage()}
      <Title>{model.name}</Title>
      {renderActions()}
    </Thumb>
  );
}

export const AssetPackItemMemoized = React.memo(AssetPackItem, (prevProps, nextProps) => {
  return (
    prevProps.model.id === nextProps.model.id &&
    prevProps.isHovered === nextProps.isHovered &&
    prevProps.style === nextProps.style
  ); // Include style if layout changes are relevant
});
